ixModuleRouting("impactx.attributes", {
    "/attributelist": {
        template: "<ixa-attribute-list></ixa-attribute-list>",
        process: "AdministrateAttributes",
        workspace: "content",
    },
    "/attributelist/:pasId": {
        template: "<ixa-attribute-list></ixa-attribute-list>",
        process: "AdministrateAttributes",
        workspace: "content",
    },
    "/attribute/:id": {
        template: "<ixa-attribute></ixa-attribute>",
        process: "AdministrateAttributes",
        workspace: "content",
    },
    "/attributeset/:id": {
        template: "<ixa-attribute-set></ixa-attribute-set>",
        process: "AdministrateAttributes",
        workspace: "content",
    },
    "/attributetree": {
        template: "<ixa-attribute-tree></ixa-attribute-tree>",
        process: "AdministrateAttributes",
        workspace: "content",
    }
});